export const convertKeyToCssVariables = (variables) => {
    Object.keys(variables).forEach((key) => {
        document.documentElement.style.setProperty(`--${key}`, variables[key]);
      });
}